import { Lock, Users, Globe, Bot } from "lucide-react";
import { STATUS_COLORS, STATUS_LABELS } from "@/lib/agendaConstants";
import { AGENDA } from "@/constants/testIds";

const SOURCE_ICONS = { manual: Users, public_booking: Globe, whatsapp_agent: Bot };

/** Render personalizado de cada turno/bloqueo dentro del calendario. */
export default function EventCard({ event }) {
  if (event.isBlock) {
    return (
      <div
        className="agenda-block-event h-full w-full rounded-md px-2 py-1 text-xs text-[#8C7D70] overflow-hidden"
        data-testid={`${AGENDA.blockEventPrefix}${event.raw.id}`}
      >
        <div className="flex items-center gap-1 font-medium"><Lock className="w-3 h-3 shrink-0" /> {event.title}</div>
      </div>
    );
  }

  const colors = STATUS_COLORS[event.status] || STATUS_COLORS.pending;
  const timeLabel = event.start.toTimeString().slice(0, 5);
  const SourceIcon = SOURCE_ICONS[event.raw.source] || Users;

  return (
    <div
      className="h-full w-full rounded-md px-2 py-1 overflow-hidden border-l-[3px] relative"
      style={{ backgroundColor: colors.bg, borderColor: colors.dot, color: colors.text }}
      data-testid={`${AGENDA.eventPrefix}${event.raw.id}`}
    >
      <SourceIcon className="w-2.5 h-2.5 absolute top-1 right-1 opacity-50" />
      <p className="text-[11px] font-medium leading-tight truncate pr-3">{timeLabel} &middot; {event.raw.patient_name}</p>
      <p className="text-[10px] leading-tight truncate opacity-80">{event.raw.service_name}</p>
      {event.raw.professional_name && (
        <p className="text-[10px] leading-tight truncate opacity-60">{event.raw.professional_name}</p>
      )}
    </div>
  );
}
